import { Customer } from "../features/trading-system/customers/CustomerAccessories";
import { NumberTypes } from "../models/enums/NumberType";

export function HasDuplicates(arry: any[]) {
    const duplicates: any[] = arry.filter((item, index) => arry.indexOf(item) !== index);

    return (duplicates.length > 0)
}

export function AwayFromZeroRounding(value: number, dp: number)
{
    let multiple: number = Math.pow(10, dp);
    let x = value * multiple;
    let decimalPart: number;

    if (x>=0)
        decimalPart = x - Math.floor(x);
    else
        decimalPart = x - Math.ceil(x);

    if (decimalPart < 0.5)
        return Math.floor(x) / multiple;
    else
        return Math.ceil(x) / multiple;
}

export function ValidateNumber(value: string, numberType: NumberTypes, isPositive: boolean)
{
    if (numberType === NumberTypes.FLOAT && isNaN(parseFloat(value.replace(/,/g, '')))) {
        return "Value must be a number!";
    } 

    if (numberType === NumberTypes.INTEGER && isNaN(parseInt(value.replace(/,/g, '')))) {
        return "Value must be a number!";
    } 

    if (numberType == NumberTypes.INTEGER && value.indexOf('.')>0) {
        return "Value must be an integer number!";
    } 

    if (isPositive)
    {
        if (parseFloat(value.replace(/,/g, '')) < 0 || parseInt(value.replace(/,/g, '')) < 0) {
            return "Value must be positive!";
        }
    }

    return "";
}

export function GetCustomerName(cust: Customer)
{
    if (cust.companyNameEng && cust.companyNameEng !== "")
        return cust.companyNameEng;
    if (cust.companyNameChi && cust.companyNameChi !== "")
        return cust.companyNameChi;
    if (cust.companyNameJpn && cust.companyNameJpn !== "")
        return cust.companyNameJpn;

    return "";
}

export function GetNoOfLines(input: string)
{
  if (input)
  {
    let i = (input.match(/\n/g)||'').length + 1;
    if (i>4)
      i = 4;
  
    return i;  
  }
  else
    return 1;
}

export function FormatDateForFileName(date: string | undefined) {
    if (date == null || date == undefined)
    {
        return "";
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year.toString().substring(2,4), month, day].join('');
}
